export default __webpack_public_path__ + "static/onboarding2-c57d866ab7121902c3e7a55e1a86b0ca.png";